import { createContext, useContext, type ReactNode } from "react";

import { resolveTaskWorkItemKey } from "~/lib/taskWorkItemKey";

const EMPTY_TASK_WORK_ITEM_KEY_INDEX: ReadonlyMap<string, string> = new Map();
const TaskWorkItemKeyContext = createContext<ReadonlyMap<string, string>>(
  EMPTY_TASK_WORK_ITEM_KEY_INDEX,
);

export function TaskWorkItemKeyProvider(props: {
  readonly children: ReactNode;
  readonly value: ReadonlyMap<string, string>;
}) {
  return (
    <TaskWorkItemKeyContext.Provider value={props.value}>
      {props.children}
    </TaskWorkItemKeyContext.Provider>
  );
}

export function useTaskWorkItemKey(anchorCmmdId: unknown): string | null {
  return resolveTaskWorkItemKey(useContext(TaskWorkItemKeyContext), anchorCmmdId);
}
